import axios from "axios";

export const state = {
    storecarts: [],
};

export const getters = {
    storecarts: state => state.storecarts,
};

export const mutations = {
    setCart(state, newValue) {
        state.storecarts = newValue
    },
};

export const actions = {
    fetchStoreCart({ commit }) {
        axios.get('/storecart').then(res => {
            commit('setCart', res.data.carts);
        })
    },
};
